var exports = {
  "container": "x24da60e8--c41c1d--container",
  "content": "x24da60e8--c41c1d--content",
  "phone": "x24da60e8--c41c1d--phone",
  "tablet": "x24da60e8--c41c1d--tablet",
  "description": "x24da60e8--c41c1d--description",
  "section": "x24da60e8--c41c1d--section",
  "banners": "x24da60e8--c41c1d--banners",
  "control": "x24da60e8--c41c1d--control",
  "action-area": "x24da60e8--c41c1d--action-area",
  "desktop": "x24da60e8--c41c1d--desktop",
  "action-area-when-sticky": "x24da60e8--c41c1d--action-area-when-sticky",
  "action-wrapper-when-sticky": "x24da60e8--c41c1d--action-wrapper-when-sticky",
  "title": "x24da60e8--c41c1d--title",
  "text": "x24da60e8--c41c1d--text",
};

module.exports = exports;
